import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '../Icon/Icon';

import { usePopupContext } from '../../Helpers/PopupProvider';

import { PopupProps } from './Popup.model';

import styles from './Popup.module.scss';

const Popup = (props: PopupProps) => {
  const { actions, contentExtraClass, height, title, children, size, onClose } = props;
  const { onPopupClose, onPopupOpen } = usePopupContext();

  useEffect(() => {
    onPopupOpen();
  }, [])

  const onClickCloseBtn = () => {
    onPopupClose(onClose);
  }

	return <div className={styles.popupContainer}>
		<div  onClick={onClose}  className={styles.backdrop} />
    <div className={`${styles.popupWrapper} ${styles.topBorder} ${size ? styles[size] : ''} ${height ? styles[height] : ''}`}>
      {title && <div className={styles.header}>
        <h1>
          {title.action && <b><FormattedMessage id={`actions.${title.action}`} />:&nbsp;</b>}
          {title.target && <FormattedMessage id={`popupTitles.${title.target}`} />}
        </h1>
			</div>}
			 <span className={styles.icon} onClick={onClickCloseBtn}>
          <Icon name='times' color='text'/>
        </span>
      <div className={`${styles.content} ${contentExtraClass}`}>
        <div className={styles.scrollable}>
        {children}
        </div>
      </div>
      {actions && <div className={styles.actions}>
        {actions}
      </div>}
    </div>
  </div>
  
}
export default Popup;